<ce-container>
    <ce-empty-state type="not-found" [actionHref]="emptyStateHref" actionLabel="Go to ChargEye Classic">
        <h1 ce-empty-state-title>Page not found</h1>
        <p ce-empty-state-description>The page you're looking for has gone missing. Please navigate back to ChargEye classic or explore elsewhere. Thank you!</p>
    </ce-empty-state>
</ce-container>
